export function isConnectionLostError(err: unknown): boolean {
  const msg =
    err instanceof Error ? err.message :
    typeof err === 'string' ? err :
    null;
  if (msg === null) return false;
  return (
    msg.includes('Connection not found') ||
    msg.includes('No connection available')
  );
}
